module.exports = __webpack_public_path__ + "img/dress7.2756e1da.jpeg";